/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { SaveUserInfo, UserInfo } from '../models/entites/userInfo';
import { RegisteredUser } from '../models/entites/registeredUser';
import { environment } from 'src/environments/environment';
import { NotificationService } from './notification.service';
import { DialogService } from './dialog.service';
import { SpinnerService } from './spinner.service';
import { Tokens } from '../models/entites/session-storage/tokens';
import { AuthenticationAPI } from '../constants/apiURL';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ROUTES } from '../constants/routes';
import { Router } from '@angular/router';

const helper: JwtHelperService = new JwtHelperService();

@Injectable({
  providedIn: 'root',
})
export class AuthentificationService {
  constructor(
    private httpClient: HttpClient,
    private notificationService: NotificationService,
    private dialogService: DialogService,
    private spinnerService: SpinnerService,
    private router: Router
  ) {}

  login(username: string, password: string): Observable<any> {
    const user = { username: username, password: password };

    return this.httpClient
      .post<any>(environment.baseUrl + AuthenticationAPI.LOGIN, user)
      .pipe(
        map((response) => {
          if (response && response.accessToken) {
            const tokens = new Tokens(
              response.accessToken,
              response.refreshToken
            );
            sessionStorage.setItem('Tokens', JSON.stringify(tokens));

            const decodedToken = helper.decodeToken(response.accessToken);
            sessionStorage.setItem('Role', JSON.stringify(decodedToken.role));
            this.dialogService.closeDialog();
            this.spinnerService.hideSpinner();
          }
          return response;
        })
      );
  }

  register(registeredUser: RegisteredUser): Observable<any> {
    return this.httpClient
      .post<UserInfo>(
        environment.baseUrl + AuthenticationAPI.REGISTER,
        registeredUser
      )
      .pipe(map((response) => response));
  }

  hideExpiringMbcNotification(clientId: string) {
    return this.httpClient
      .put<UserInfo>(
        environment.baseUrl + AuthenticationAPI.HIDE_EXPIRING_MBC_NOTIFIACTION,
        clientId
      )
      .pipe(map((response) => response));
  }

  saveUserInfo(modifiedUser: SaveUserInfo): Observable<SaveUserInfo> {
    const user = { ...modifiedUser };
    return this.httpClient
      .post<SaveUserInfo>(
        environment.baseUrl + AuthenticationAPI.SAVE_USER_INFO + user.client_ID,
        user
      )
      .pipe(map((response) => response));
  }

  refreshToken(): Observable<any> {
    const refreshRequest = {
      accessToken: this.getAccessToken(),
      refreshToken: this.getRefreshToken(),
    };

    return this.httpClient
      .post<any>(
        environment.baseUrl + AuthenticationAPI.REFRESH_TOKEN,
        refreshRequest
      )
      .pipe(
        map((response) => {
          if (response && response.accessToken) {
            const tokens = new Tokens(
              response.accessToken,
              response.refreshToken
            );
            sessionStorage.setItem('Tokens', JSON.stringify(tokens));
            this.dialogService.closeDialog();
            this.spinnerService.hideSpinner();
          }
          return response.accessToken;
        })
      );
  }

  recover(email: string): Observable<any> {
    const user = { email: email };
    return this.httpClient
      .post<any>(environment.baseUrl + AuthenticationAPI.RECOVER, user)
      .pipe(map((response) => response));
  }

  logout() {
    this.notificationService.disconnectFromSignalR();
    this.spinnerService.hideSpinner();
  }

  getAccessToken() {
    const tokens = JSON.parse(sessionStorage.getItem('Tokens')!) as Tokens;
    if (tokens == null) {
      return null;
    }
    return tokens.accessToken;
  }

  getRefreshToken() {
    const tokens = JSON.parse(sessionStorage.getItem('Tokens')!) as Tokens;
    if (tokens == null) {
      return null;
    }
    return tokens.refreshToken;
  }
}
